import React from 'react';
import { Users, School } from 'lucide-react';

const StudentLoginForm = ({
  studentId,
  onStudentIdChange,
  classId,
  onClassIdChange,
  loginError,
}) => {
  return (
    <div className="space-y-4 px-6">
      <div>
        <label className="block text-xs text-gray-400 mb-1.5">学号</label>
        <div className="relative">
          <Users
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            size={16}
          />
          <input
            value={studentId}
            onChange={(e) => onStudentIdChange(e.target.value)}
            placeholder="请输入学号"
            className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
      <div>
        <label className="block text-xs text-gray-400 mb-1.5">班级号</label>
        <div className="relative">
          <School
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            size={16}
          />
          <input
            value={classId}
            onChange={(e) => onClassIdChange(e.target.value)}
            placeholder="请输入班级号"
            className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {loginError && <div className="text-red-500 text-sm">{loginError}</div>}
    </div>
  );
};

export default StudentLoginForm;
